import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineHome, AiOutlineFolder, AiOutlineFile, AiOutlineTag } from "react-icons/ai";

const Breadcrumb = ({ path, onBreadcrumbClick }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      {/* Icono de Inicio */}
      <AiOutlineHome style={styles.icon} />
      <span
        style={styles.link}
        onClick={() => onBreadcrumbClick(-1)}
      >
        Inicio
      </span>

      {path.map((folder, index) => (
        <React.Fragment key={folder.id}>
          <span style={styles.separator}>{">"}</span>
          {folder.isSeries ? (
            <AiOutlineTag style={styles.icon} />
          ) : (
            <AiOutlineFolder style={styles.icon} />
          )}
          <span
            style={styles.link}
            onClick={() => onBreadcrumbClick(index)}
          >
            {folder.name}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    fontSize: "16px",
    color: "#00468B",
    fontWeight: "bold",
  },
  icon: {
    marginRight: "4px",
    fontSize: "18px",
    color: "#00468B",
  },
  link: {
    color: "#00468B",
    cursor: "default",
    fontWeight: "bold",
  },
  separator: {
    margin: "0 8px",
    color: "#777",
  },
};

export default Breadcrumb;
